// extracted by mini-css-extract-plugin
module.exports = {"capitalize":"_3vFlih-l","lowercase":"_1bEfiEwt"};